import { assertNever } from 'assert-never';
import { ZAKAZKA_ND, ZAKAZKA_ND_PENDING } from '../constants';
import { DOKLAD_OSTATNI, ADVANCEPAY, ATTACHMENT_FILES, NONGENUINE_ATTACHMENT_FILES } from '../doklad/constants';
import { NAME as ZAKAZKA_PRACOVNI_POZICE, ZAKAZKA_PP_PENDING } from './pracovniPozice/constants';
import { NAME as ZAKAZKA_CIZI_VYKONY } from './ciziVykony/constants';
import { NAME as ZAKAZKA_KOREKCE } from './korekce/constants';
import { ODLOZENE_SERVISNI_CINNOSTI } from './components/odlozeneServisniCinnosti/constants';
import { CUSTOMER_FEEDBACK } from './components/customerFeedback/constants';

export { ZAKAZKA_PP_PENDING } from './pracovniPozice/constants';
export { ATTACHMENT_FILES } from '../doklad/constants';
export const SERVICE_PKG_PARTS = 'ServicePackageParts';
export const SERVICE_PKG_LABOR = 'ServicePackageLabor';
export const SERVICE_PACKAGE = 'ServicePackage';
export const CAMPAIGN_DETAILS = 'Campaign';
export { ODLOZENE_SERVISNI_CINNOSTI } from './components/odlozeneServisniCinnosti/constants';
export { CUSTOMER_FEEDBACK } from './components/customerFeedback/constants';
export { DMS_MODULE, ZAKAZKA_ND, ZAKAZKA_ND_PENDING } from '../constants';
export const GDPR = 'GDPR';
export const PENDING_JOB_LIST = 'PendingJoblist';
export const CRUMB_LABEL_KEY = 'grdZakazka';
export const NAME = 'Zakazka';
export const MENU_CODE = 'Zakazka';
export const REF_TABLE = 'RefTable';
export const VYDEJKA = 'Vydejka';
export const VYDEJKAND = 'VydejkaNd';
export const ZAKAZKA_CONTROL = 'ZakazkaControl';
export const ZAKAZKANDREZ = 'ZakazkaRezervaceNd';
export const ZAKAZKA_ZAPUJCKA = 'ZakazkaZapujcka';
export const ZAKAZKA_PNEU = 'ZakazkaPneu';
export const SAGA_2_HLAV = 'Saga2Hlav';
export const SAGA_2_POL = 'Saga2Pol';
export const SAGA_2_KOM = 'Saga2Komunikace';
export const ZAKAZKA_PLAN_SKUT = 'PlanSkut';
export const PNEU = 'ZakazkaPneu';
export const KOREKCE = 'ZakazkaKorekce';
export const CIZI_VYKONY = 'ZakazkaCiziVykony';
export const PRACOVNI_POZICE = 'ZakazkaPracovniPozice';
export const ELSA_R = 'ElsaR';
export const ZAK_ZALOHA = 'ZakazkaZaloha';
export const OZAKAZKA_ON_VOZIDLO = 'OzakazkaOnVozidlo';
export const OTEVRENE_ZAKAZKY = 'zakazka';
export { DOKLAD_OSTATNI, ADVANCEPAY, NONGENUINE_ATTACHMENT_FILES } from '../doklad/constants';
export const RESERVE_PARTS = 'ReserveParts';
export const PART_RETURN_REQUEST = 'PartReturnRequest';
export const HEALTH_CARD = 'HealthCard';
export const POLOZKY = 'Polozky';
export const SPLIT_VALUE_MIN = 0;
export const SPLIT_VALUE_MAX = 100;
export const NO_DATA_FOUND = 'NO_DATA_FOUND';
export const MANDATORY_CAMPAIGN = 'Mandatory';
export const OPTIONAL_CAMPAIGN = 'Optional';
export const AUDATEX = 'Audatex';
export const SERVICE_JOB_DETAILS = 'ServiceJobDetails';
export const SERVICE_JOB_SPLIT_BILLING = 'ServiceJobSplitBilling';
export const SPLIT_BILLING = 'SplitBilling';
export const PARTS = 'PARTS';
export const LABOUR = 'LABOUR';
export const BILLING_OPERATION_CODE ='OP_BILLING';
export const SAVE_ORDER = 'Saved';
export const RELEASE_ORDER = 'Released';
export const LOAD_ORDER = 'Loaded';
export const SAGA_ITEM_ADJUSTED = 'SAGA Item Adjusted';

export enum PlatbaTyp {
	NET_BANKING = 0,
	CASH = 1,
	CREDIT_CARD = 2,
	POSTAL_CARD = 3,
	FOREIGN_CURRENCY = 4,
	DONT_PAY = 98,
	INTERNAL = 99,
	NEFT = 100,
	DEBIT_CARD = 101,
	MOBILE_WALLET = 102,
	UPI = 103,
	CHEQUE = 104
}

export enum POLOZKA_STATUS {
	CEKANI = 0,
	UZNANO = 1,
	ZAMITNUTO = 2,
	NAVRH = 3,
	ZMENA = 4,
	NAHRADA_AB = 5,
	NAHRADA_BA = 6,
	AKCEPT_NAVRH = 7,
	ERR_STATE = 8,
}

export enum POLOZKA_DRUH {
	PP = 0,
	ND = 1,
	CV = 2,
}

export enum MIO_TYPE {
	NEUVOLNOVAT = 0,
	RUCNI = 3,
	AUTO = 4,
}

export enum DZM_TYPE {
	ZAVADY_NEODSTRANENY = 0,
	PRODLOUZIT = 3,
	NEPRODLUZOVAT = 4,
}

export enum ZAKAZKA_DRUH {
	PRODEJ_PULT = 'Z',
	PREVOD_ND = 'S',
	PRODEJ_ZBOZI = 'B',
	ZAPUJCKA = 'F',
	INTERNI_PRODEJ = 'J',
	DROBNE_SLUZBY = 'C',
	ZPETNY_ODKUP_ND = 'R',
	DILENSKA = 'W',
	GARANCE = 'G',
	INTERNI_DILENSKA = 'I',
	KULANCE = 'K',
	MONTAZ_DV = 'P',
	UDRZBA_OV = 'O',
	SKODA_TIP = 'N',
}

export enum AUDATEX_OPTIONS {
	SEND_TO_AUDATEX = 'sendToAudatex',
	DOWNLOAD_RESULT_FROM_AUDATEX = 'downloadResultFromAudatex',
	RETRIEVE_AUDATEX_TASK_LIST = 'retrieveAudatexTaskList',
}

export enum ORDER_SUB_TYPES {
	BODY_SHOP_REPAIR = 3,
	PDI = 4,
	RUNNING_REPAIR = 1,
	PDI_BODY_SHOP_C = 48,
	BODY_PAINT_V = 54,
	PDI_V = 59,
	BODY_PAINT_A = 65,
	PDI_A = 68,
	PDI_S = 49,
}

export enum WORKFLOW_STATES {
	GARANCE = 'Garance',
	INTERNI = 'Interni',
}

export enum ZAKAZKA_CDB_STATUS {
	KOMUNIKACE = -3,
	STATUS_ERROR = -2,
	CHYBA_VERZE = -1,
	OK = 0,
	NOVA_VERZE = 1,
	CHYBA_ZTOTOZNENI = 2,
}
export const ZAKAZKA_DRUH_LOCALIZED = {
	W: 'Dilna',
	Z: 'ProdejPult',
	B: 'ProdejZbozi',
	J: 'InterniProdej',
	P: 'Servis',
	F: 'Zapujcka',
	I: 'InterniDilna',
	K: 'Kulance',
	G: 'Garance',
	S: 'Prevod',
	O: 'UdrzbaOV',
	R: 'Vraceni',
	C: 'DrobneSluzby',
	// TODO: dodat podle toho jak se budou jednotlivé druhy implementovat / případně nějak rozšířit ZAKAZKA_DRUH
};
export const RequiredOrderType = {
	W: 'Dilna',
	B: 'ProdejZbozi',
	S: 'Prevod',
};

export enum SDAKontext {
	eAdministrace,
	eUvolneniZakazky
}

export enum ADDITIONAL_WORK_STATUS {
	CUSTOMER_APPROVAL_PENDING = 'Customer Approval Pending',
	CUSTOMER_APPROVED = 'Customer Approved',
	CUSTOMER_REJECTED = 'Customer Rejected',
}

export enum REPEAT_REPAIR_STATUS {
	OTHER = 'OT',
	NOT_APPLICABLE = 'NA'
}

export enum ZAKAZKA_STAV {
	V_PRIPRAVE = 1,
	OTEVRENA = 2,
	UVOLNENA = 3,
	UZAVRENA = 4,
	VYRAZENA = 5,
	NABIDKA = 6,
}

export enum CommunicationModeEnum {
	SMS = 1,
	EMAIL = 2,
	WhatsApp = 3
}

export enum AdditionalStatus {
	IsAdded = 1
}
export enum PART_ADD_STATUS {
	ORDER = 0,
	PART,
	JOB,
}

export function zakazkaStateLocalized(state: ZAKAZKA_STAV) {
	switch (state) {
		case ZAKAZKA_STAV.V_PRIPRAVE: return 'ZakazkStatus1';
		case ZAKAZKA_STAV.NABIDKA: return 'ZakazkStatus6';
		case ZAKAZKA_STAV.OTEVRENA: return 'ZakazkStatus2';
		case ZAKAZKA_STAV.UVOLNENA: return 'ZakazkStatus3';
		case ZAKAZKA_STAV.UZAVRENA: return 'ZakazkStatus4';
		case ZAKAZKA_STAV.VYRAZENA: return 'ZakazkStatus5';
		default: return assertNever(state);
	}
}

export const DEPENDENT_TABLES = <const>[
	// https://www.typescriptlang.org/docs/handbook/release-notes/typescript-3-4.html#const-assertions
	ZAKAZKA_ND,
	ADVANCEPAY,
	ZAKAZKA_CIZI_VYKONY,
	ZAKAZKA_KOREKCE,
	REF_TABLE,
	VYDEJKA,
	GDPR,
	PENDING_JOB_LIST,
	VYDEJKAND,
	ZAKAZKA_PRACOVNI_POZICE,
	ZAKAZKA_CONTROL,
	ZAKAZKA_ZAPUJCKA,
	ZAKAZKA_PNEU,
	SAGA_2_HLAV,
	SAGA_2_POL,
	SAGA_2_KOM,
	ZAKAZKA_PLAN_SKUT,
	DOKLAD_OSTATNI,
	ATTACHMENT_FILES,
	ZAK_ZALOHA,
	ODLOZENE_SERVISNI_CINNOSTI,
	OZAKAZKA_ON_VOZIDLO,
	OTEVRENE_ZAKAZKY,
	SERVICE_PKG_PARTS,
	SERVICE_PKG_LABOR,
	POLOZKY,
	ZAKAZKA_ND_PENDING,
	ZAKAZKA_PP_PENDING,
	RESERVE_PARTS,
	CUSTOMER_FEEDBACK,
	CAMPAIGN_DETAILS,
	NONGENUINE_ATTACHMENT_FILES,
	SERVICE_JOB_DETAILS
];

export enum SMLUVNI_PARTNER_TYP {
	ZAKAZNIK,
	POJISTOVNA,
	LEASING_FIRMA,
	JINY_PRIJEMCE,
}

export type DependentTableNames = typeof DEPENDENT_TABLES[number];

export enum TAB_NAMES {
	HLAVNI = 'Hlavni',
	ADVANCEPAY = 'AddvancePay',
	PRAC = 'Prac',
	ND = 'ND',
	CIZI_VYKONY_SLEVY_KOREKCE = 'CiziVykonySlevyKorekce',
	KALKULACE = 'Kalkulace',
	ZALOHY = 'Zalohy',
	VYDEJKY = 'Vydejky',
	HISTORY = 'History',
	POZNAMKY = 'Poznamky',
	ZARAZENI = 'Zarazeni',
	ZAKAZKY_REF = 'ZakazkyRef',
	REFERENCE = 'Reference',
	GDPR = 'GDPR',
	ZAPUJCKY_REF = 'ZapujckyRef',
	SAGA_2 = 'Saga2',
	SAGA_2_KOMUNIKACE = 'Saga2Komunikace',
	PLAN_SKUTECNOST = 'PlanSkutecnost',
	DOKLAD = 'Doklady',
	ZAKAZKY_OSC = 'OSC',
	PARTS_RESERVE = 'ReserveParts',
	CUSTOMER_FEEDBACK = 'CustomerFeedback',
	HEALTH_CARD = 'HealthCard',
}

export const TABS = {
	[TAB_NAMES.HLAVNI]: { id: TAB_NAMES.HLAVNI, labelKey: 'HlavniUdaje' },
	[TAB_NAMES.ADVANCEPAY]: { id: TAB_NAMES.ADVANCEPAY, labelKey: 'cmdAdvancePay' },
	[TAB_NAMES.PRAC]: { id: TAB_NAMES.PRAC, labelKey: 'tsPPND' },
	[TAB_NAMES.ND]: { id: TAB_NAMES.ND, labelKey: 'cmdND' },
	[TAB_NAMES.CIZI_VYKONY_SLEVY_KOREKCE]: { id: TAB_NAMES.CIZI_VYKONY_SLEVY_KOREKCE, labelKey: ['CvZkt', 'Slevy'] },
	[TAB_NAMES.KALKULACE]: { id: TAB_NAMES.KALKULACE, labelKey: 'pageKalk' },
	[TAB_NAMES.ZALOHY]: { id: TAB_NAMES.ZALOHY, labelKey: 'pageZaloha' },
	[TAB_NAMES.VYDEJKY]: { id: TAB_NAMES.VYDEJKY, labelKey: 'zalVydejky' },
	[TAB_NAMES.HISTORY]: { id: TAB_NAMES.HISTORY, labelKey: 'tsHistorie' },
	[TAB_NAMES.POZNAMKY]: { id: TAB_NAMES.POZNAMKY, labelKey: ['cmdText', 'PoznZkt'] },
	[TAB_NAMES.ZARAZENI]: { id: TAB_NAMES.ZARAZENI, labelKey: 'Zarazeni' },
	[TAB_NAMES.ZAKAZKY_REF]: { id: TAB_NAMES.ZAKAZKY_REF, labelKey: 'PodradZakaz' },
	// TODO: uncomment after prepare this tab
	[TAB_NAMES.REFERENCE]: { id: TAB_NAMES.REFERENCE, labelKey: 'Reference' },
	[TAB_NAMES.GDPR]: { id: TAB_NAMES.GDPR, labelKey: 'TabSheetGDPR' },
	[TAB_NAMES.ZAPUJCKY_REF]: { id: TAB_NAMES.ZAPUJCKY_REF, labelKey: 'tsZakazkaPaPneu' },
	[TAB_NAMES.SAGA_2]: { id: TAB_NAMES.SAGA_2, labelKey: 'zalSaga2' },
	[TAB_NAMES.SAGA_2_KOMUNIKACE]: { id: TAB_NAMES.SAGA_2_KOMUNIKACE, labelKey: 'Saga2Komun' },
	[TAB_NAMES.PLAN_SKUTECNOST]: { id: TAB_NAMES.PLAN_SKUTECNOST, labelKey: 'cmdPlanSkut' },
	[TAB_NAMES.DOKLAD]: { id: TAB_NAMES.DOKLAD, labelKey: ['cmdDoklad', 'cmdAttachments'] },
	[TAB_NAMES.ZAKAZKY_OSC]: { id: TAB_NAMES.ZAKAZKY_OSC, labelKey: 'VozZavadaZkt' },
	[TAB_NAMES.PARTS_RESERVE]: { id: TAB_NAMES.PARTS_RESERVE, labelKey: 'PartsReserve' },
	[TAB_NAMES.CUSTOMER_FEEDBACK]: { id: TAB_NAMES.CUSTOMER_FEEDBACK, labelKey: 'CustomerFeedback' },
	[TAB_NAMES.HEALTH_CARD]: { id: TAB_NAMES.HEALTH_CARD, labelKey: 'HealthCard' },

};

export const ADDITIONAL_TAB_CLICK_HANDLE: string[] = [
	TAB_NAMES.KALKULACE,
	TAB_NAMES.PRAC,
	TAB_NAMES.POZNAMKY,
	TAB_NAMES.ADVANCEPAY,
	TAB_NAMES.CUSTOMER_FEEDBACK,
	TAB_NAMES.CIZI_VYKONY_SLEVY_KOREKCE,
	TAB_NAMES.ZAKAZKY_REF,
	TAB_NAMES.VYDEJKY,
	TAB_NAMES.GDPR,
	TAB_NAMES.ND,
	TAB_NAMES.PARTS_RESERVE,
	TAB_NAMES.HISTORY,
	TAB_NAMES.SAGA_2,
	TAB_NAMES.SAGA_2_KOMUNIKACE,
	TAB_NAMES.DOKLAD,
];

export enum KALKULACE_DRUH {
	SILVER_DAT_BTAC = 1,
	AUDATEX = 2,
	SILVER_DAT_CALCULATE_PRO = 3,
}

export enum ClientResponsesEnum {
	Yes = 'Yes',
	No = 'No',
	Ok = 'Ok',
	Cancel = 'Cancel',
	Continue = 'Continue',
}

export enum LINE_ITEM_STATUS {
	PART_NOT_AVAILABLE = 1,
	JOB_NOT_COMPLETE_BEFORE_DELIVERY = 2,
	CUSTOMER_DENIED = 3,
	OTHER = 4,
	NOT_SELECTED = 0,
}

export enum OrderReports {
	CourtesyCarAgreement = 'CCA',
	ServiceQuote = 'SQ',
	WorkShopCopy = 'WC',
	PartsSalesOrder = 'PSO',
	PMSIssueSlip = 'PIS',
	PMSRequisitionSlip = 'PRS',
	WarrantyIssueSlipReport = 'WIR',
	WarrantyNoteReport = 'WNR',
	CustomerSatisfactionSkodaReport = 'CS',
	CustomerSatisfactionVWReport = 'CS',
	ServiceInternalReport = 'SIR',
	QuickEstimateReport = 'QE',
	DetailEstimateReport = 'QED',
	CustomerCopyReport = 'CC',
	PickingListReport = 'SRF',
	ServiceOrderConfirmationReport = 'SOC',
	ServiceOrderConfirmationDetailedReport = 'SOCD',
	ServiceOrderConfirmationDetailedCustomerReport = 'SOCDC',
	VehicleReceptionChecklistReport = 'VRC',
	ServiceOrderConfirmationReportV2 = 'SOC_V2',
	ServiceOrderConfirmationDetailedReportV2 = 'SOCD_V2',
	ServiceQuoteV2 = 'SQ_V2',
	ServiceOrderConfirmationDetailedInternalReport = 'SOCDI'
}

export enum REPORT_TYPES {
	CourtesyCarAgreement = 'CCA',
	ServiceQuote = 'SQ',
	WorkShopCopy = 'WC',
	CustomerCopy = 'CC',
	ServiceCreditMemo = 'SCM',
	PartsSalesOrder = 'PSO',
	PMSIssueSlip = 'PIS',
	PMSRequisitionSlip = 'PRS',
	WarrantyIssueSlipReport = 'WIR',
	WarrantyNoteReport = 'WNR',
	CustomerSatisfactionSkodaReport = 'CS',
	CustomerSatisfactionVWReport = 'CS',
	ServiceInternalReport = 'SIR',
	QuickEstimateReport = 'QE',
	QuickEstimateDetailedReport = 'QED',
	StoreRequisitionForm = 'SRF',
	GatePass = 'GP',
	GoodReceivedNote = 'GRN',
	PartReturnForm = 'PRF',
	PickingList = 'PL',
	ServiceOrderConfirmation = 'SOC',
	ServiceOrderConfirmationDetailed = 'SOCD',
	VehicleReceptionChecklist = 'VRC',
	ServiceOrderConfirmationReportV2 = 'SOC_V2',
	ServiceOrderConfirmationDetailedReportV2 = 'SOCD_V2',
	ServiceQuoteV2 = 'SQ_V2',
	ServiceOrderConfirmationDetailedInternalReport = 'SOCDI'
}
export enum CANCELLATION_REASON_TYPES {
	OTHER = 5,
	NOT_APPLICABLE = 0,
}
export enum SPLIT_BY {
	PERCENTAGE = 1,
	AMOUNT = 2,
}

export enum JOB_STATUS {
	COMPLETED = 1,
	PENDING = 2,
	PENDING_OTHER = 4
}

export enum ADDITIONAL_JOB_STATUS {
	PENDING = 0,
	ADDITIONAL = 1,
	NON_ADDITIONAL = 2,
	APPROVED = 3
}

export enum CANCELLATION_REASONS {
	OTHER = 5,
}

export enum EGUI_OPTIONS {
	EGUI_ISSUE = 'issueInvoice',
	EGUI_PRINT = 'printInvoice',
	EGUI_CANCEL = 'cancelInvoice',
	EGUI_RTN_CODE = 7
}

export enum EGUI_TRANS_OPTIONS {
	SEPERATE = 1,
	COMBINE = 2
}
export enum EGUI_TYPES {
	COMPANY = 1,
	WITH_CARRIER = 2,
	NO_CARRIER = 3
}

export const LOAD_SERVICE_ORDER_CONFIRMATION = 'Load Service Order Confirmation ';
export const LOAD_SERVICE_ORDER_CONFIRMATION_DETAILED = 'Load Service Order Confirmation Detailed';
export const LOAD_SERVICE_ORDER_CONFIRMATION_DETAILED_CUSTOMER = 'Load Service Order Confirmation Detailed Customer';